import { api as ambassadorsApi } from './auto-generated/ambassadors'

ambassadorsApi.enhanceEndpoints({
  endpoints: {},
})

export { ambassadorsApi }
